import React from 'react';
import { FDLozenge, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const GoalDetailHeader = () => {
  const {
    resource,
  } = useMetaLayoutContext();
  return (
    <FDStack direction={'column'} spacing={2} alignItems={'center'} width={'100%'}>
      <FDLozenge color={'info'} label={resource.attr('goalNumber')} />
      <MetaControlField attr={'title'} simpleRootStyle />
      <MetaControlField attr={'subtitle'} simpleRootStyle />
    </FDStack>
  );
};

GoalDetailHeader.defaultProps = {};

GoalDetailHeader.propTypes = {};

export { GoalDetailHeader };
